import AccountTemplate from 'src/components/atomic/template/Account'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import useMatchHook from 'src/hooks/useMatch.hook'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { ResetErrText } from 'src/store/Reducer/common/commonSlice'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { SocketSender } from 'src/api/socket'

const AccountPage = () => {
  const { pathname } = useLocation()
  const { m_login, m_reset } = useMatchHook()
  const navigate = useNavigate()
  const { deleteStorageData, getStorageData } = SessionStorageUtils()
  const { Email } = useAppSelector((state: RootState) => state.LoginPage)
  const { socket_connected } = useAppSelector((state: RootState) => state.socket)
  const { loginStatus } = useAppSelector((state: RootState) => state.common)
  const dispatch = useAppDispatch()

  useEffect(() => {
    switch (pathname) {
      case m_login?.pathname:
        loginStatus && socket_connected && dispatch(SocketSender<unknown>(Cmdtypes.LOGOUT))
        if (getStorageData('errorModalMsg') !== '' || getStorageData('userInfo').Email !== 'test') {
          deleteStorageData()
        }
        break
      case m_reset?.pathname:
        Email === '' && navigate('/')
        break
      default:
        break
    }
    return () => {
      dispatch(ResetErrText())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return <AccountTemplate />
}
export default AccountPage
